<template>
    <div style="position: relative">
        <slot></slot>
        <v-overlay :value="showOverlay" :color="color" absolute>
            <v-progress-circular
                size="80"
                width="6"
                color="amber"
                indeterminate
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
        },
        color: {
            type: String,
            default: '#FFFFFF',
        },
    },
    data() {
        return {
            showOverlay: false,
        }
    },
    watch: {
        show: {
            immediate: true,
            handler(show) {
                this.showOverlay = show
            },
        },
    },
}
</script>
